
import DropDownMenuItem from '@/components/FileViewerModules/Chattable/DropDownMenuItem.vue'
import DropDownMenu from '@/components/FileViewerModules/Chattable/DropDownMenu.vue'

export default {
    name: 'FilterInput',
    components: { DropDownMenu, DropDownMenuItem },
    props: {
        value: {},
        values: {
            type: Array,
            required: true
        }
    },
    computed: {
        selectedValue () {
            return this.values.find(v => v.val === this.value)
        }
    }
}

